/**
 * @fileoverview Data operations and helpers for patients
 *
 * Schema:
 *   name: string
 *   firstName: string
 *   present: boolean
 *   joined: boolean
 *   role: string
 */

export default function Patient (...data) {
  let patient = {
    name: '',
    firstName: '',
    present: false,
    joined: false,
    role: 'patient',
    phoneNumber: '',
    newPatient: false,
    zipCode: ''
  }

  Object.assign(patient, ...data)

  return patient
}
